import styled, { createGlobalStyle } from 'styled-components';
import {
  COLOR_CV_1,
  COLOR_CV_5,
  COLOR_CV_6,
  COLOR_MEDIUM_GRAY,
  COLOR_NEUTRAL_10,
  COLOR_NEUTRAL_3,
  COLOR_WHITE,
} from 'constants/colors';

export const GlobalStyle = createGlobalStyle`
  body {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-size: 16px;
    color: ${COLOR_NEUTRAL_10};

    // Filter dropdown overrides
    .ant-table-filter-dropdown {
      & .ant-dropdown-menu {

        // Checkbox (Copy from Checkbox UI component)
        .ant-checkbox-checked .ant-checkbox-inner {
          &, &:hover {
            background-color: ${COLOR_CV_6};
            border-color: ${COLOR_CV_6};
          }
        }
      
        .ant-checkbox-checked {
          &, &::after {
            border-color: ${COLOR_CV_6};
          }
        }
      
        &.ant-checkbox-wrapper:hover .ant-checkbox-inner,
        &.ant-checkbox:hover &.ant-checkbox-inner,
        .ant-checkbox-input:focus + .ant-checkbox-inner {
          border-color: ${COLOR_CV_6};
        }

        // Radio
        .ant-radio-wrapper:hover .ant-radio,
        .ant-radio:hover .ant-radio-inner,
        .ant-radio-input:focus + .ant-radio-inner {
          border-color: ${COLOR_CV_6};
        }

        .ant-radio-checked {
          &::after {
            border: 1px solid ${COLOR_CV_6};
          }

          & .ant-radio-inner {
            border-color: ${COLOR_CV_6};
            box-shadow: 0 0 0 3px ${COLOR_CV_6}08;
  
            &::after {
              background-color: ${COLOR_CV_6};
            }
          }
        }

        // Selection
        &-item-selected {
          color: ${COLOR_CV_6};
          // background-color: ${COLOR_CV_1};
          background-color: ${COLOR_WHITE};

          & > a {
            color: ${COLOR_CV_6};
            // background-color: ${COLOR_CV_1};
            background-color: ${COLOR_WHITE};
          }
        }

        &-submenu-title-selected {
          color: ${COLOR_CV_6};
          background-color: ${COLOR_CV_1};

          & > a {
            color: ${COLOR_CV_6};
            background-color: ${COLOR_CV_1};
          }
        }
      }

      // Button (Copy from Button UI component)
      .ant-btn-primary {
        &, &:active, &:focus {
          background-color: ${COLOR_CV_6};
          color: ${COLOR_WHITE};
          border-color: ${COLOR_CV_5};
        }
      
        &:hover {
          background-color: ${COLOR_CV_5};
          color: ${COLOR_WHITE};
          border-color: ${COLOR_CV_5};
        }
      
        &:active, &:focus {
          border-color: ${COLOR_CV_5};
        }
      }
    }

    // Select dropdown overrides
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: ${COLOR_NEUTRAL_3}
    }

    // Date picker overrides
    .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
    .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
    .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
      background: ${COLOR_CV_6};
    }

    .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
      border: 1px solid ${COLOR_CV_6};
    }
  }
`;

export const BaseContainer = styled.div`
  background-color: ${COLOR_MEDIUM_GRAY};
  min-height: 100vh;
  min-width: 100%;
`;
